export default __webpack_public_path__ + "static/media/gallery-1.8a83d9e0.jpg";